import { Controller } from "@hotwired/stimulus"
import { showToast } from "../lib/toast"
import { ping } from "../lib/ping"
import { trackEvent } from "../lib/analytics"

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    url: String,
    eventId: String
  }

  async share(event) {
    event.preventDefault()

    // Get URL and remove favourites param (it's personal, not shareable)
    const url = new URL(this.urlValue || window.location.href)
    url.searchParams.delete("favourites")

    const shareData = {
      title: this.titleValue || document.title,
      text: this.textValue || "",
      url: url.toString()
    }

    ping("share", { event_id: this.eventIdValue, url: url.pathname })
    trackEvent("share", { event_id: this.eventIdValue, kind: this.eventIdValue ? "event" : "page" }, this.element)

    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData)
      } catch (err) {
        // User cancelled or share failed - fall back to clipboard
        if (err.name !== "AbortError") {
          this.copyToClipboard(shareData.url)
        }
      }
    } else {
      // Fallback: copy URL to clipboard
      this.copyToClipboard(shareData.url)
    }
  }

  async copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text)
      showToast("Link copied", { icon: "check" })
    } catch (err) {
      // Final fallback for older browsers
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
      showToast("Link copied", { icon: "check" })
    }
  }
}
